import React, { useContext } from 'react';
import { useFormContext } from 'react-hook-form';
import { SubmitFormContext } from '../../context';
import OAuthGrantTypeField from './OAuthGrantTypeField';
import OAuthRedirectUriField from './OAuthRedirectUriField';
import OAuth2ClientTypeField from './OAuth2ClientTypeField';
import OAuth2ClientTypeHelperText from './OAuth2ClientTypeHelperText';
import OAuth2Upgrade21Checkbox from './OAuth2Upgrade21Checkbox';
import DownloadUrlField from './DownloadUrlField';
import OriginalUrlsWhitelist from './OriginalUrlsWhitelistField';

const ApplicationFieldsGroup: React.FC<{}> = () => {
  const { initResponse } = useContext(SubmitFormContext) ?? {};
  const { watch } = useFormContext();
  const oauth2Upgrade21 = watch('oauth2Upgrade21');
  const isOauth20 = initResponse?.app?.isOauth20;
  const isLegacyMode = isOauth20 === false || oauth2Upgrade21 === true;

  return (
    <>
      {isOauth20 && <OAuth2Upgrade21Checkbox />}
      {!isLegacyMode && <OAuthGrantTypeField />}
      <OAuthRedirectUriField />
      {isLegacyMode && <OAuth2ClientTypeField />}
      {isLegacyMode && <OAuth2ClientTypeHelperText />}
      <DownloadUrlField />
      <OriginalUrlsWhitelist />
    </>
  );
};
ApplicationFieldsGroup.displayName = 'ApplicationFieldsGroup';

export default ApplicationFieldsGroup;
